import { useState } from "react";
import { ListPage } from "../components/page/ListPage";
import { CreatePage } from "../components/page/CreatePage";
import { UpdatePage } from "../components/page/UpdatePage";

export const Page = () => {
  const [mode, setMode] = useState<"list" | "create" | "edit">("list");
  const [selectedId, setSelectedId] = useState<string | null>(null);

  if (mode === "create") {
    return <CreatePage onBack={() => setMode("list")} />;
  }

  if (mode === "edit" && selectedId) {
    return (
      <UpdatePage
        onBack={() => {
          setSelectedId(null);
          setMode("list");
        }}
        selectedId={selectedId}
      />
    );
  }

  return (
    <ListPage
      onCreate={() => setMode("create")}
      onUpdate={(id: string) => {
        setSelectedId(id);
        setMode("edit");
      }}
    />
  );
};
